import { Component, OnInit, inject, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'app-verify-otp',
  standalone: true,
  imports: [ReactiveFormsModule, RouterLink],
  templateUrl: './verify-otp.component.html',
  styleUrl: './verify-otp.component.scss',
})
export class VerifyOtpComponent implements OnInit {
  private readonly fb = inject(FormBuilder);
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);

  readonly loading = signal(false);
  readonly error = signal<string | null>(null);
  readonly email = signal('');

  readonly form = this.fb.nonNullable.group({
    otp: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(8), Validators.pattern(/^\d+$/)]],
  });

  ngOnInit(): void {
    const email = this.auth.getPendingEmail() || '';
    this.email.set(email);

    if (!email) {
      void this.router.navigate(['/login']);
    }
  }

  submit(): void {
    if (this.form.invalid || this.loading() || !this.email()) {
      this.form.markAllAsTouched();
      return;
    }

    this.loading.set(true);
    this.error.set(null);

    this.auth.verifyOtp(this.email(), this.form.controls.otp.value).subscribe({
      next: () => {
        this.loading.set(false);
        void this.router.navigate(['/dashboard']);
      },
      error: (err: { message?: string }) => {
        this.loading.set(false);
        this.error.set(err?.message || 'OTP verification failed');
      },
    });
  }
}
